module.exports = __webpack_public_path__ + "29b2478f31b5fed9f39c54b7a6c97d16.pdf";